<template>
  <div class="agency-screen">
    <b-tabs class="tabs-payment">
      <b-tab>
        <template v-slot:title>
          <span>{{ $t("userDashboard.agency.createCompany") }}</span>
        </template>
        <div class="modal-body form-group">
          <h5>{{$t('The request is complete only when you upload your company logo')}}</h5>
          <div class="input-div col" id="input-group-search">
            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{ $t("agency.name") }}</label>
              <b-form-input
                :class="{
                  'input-error': validateErrors ? validateErrors.name : false,
                }"
                class="input-search"
                ref="searchInput"
                :placeholder="$t('agency.name')"
                v-model="agency.name"
              ></b-form-input>
            </div>

            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{ $t("agency.companyEmail") }}</label>
              <b-form-input
                class="input-search"
                ref="searchInput"
                :placeholder="$t('agency.companyEmail')"
                v-model="agency.email"
              ></b-form-input>
            </div>
            <div class="d-flex flex-column justify-content-start m-3">
              <label>{{ $t("agency.companyPhone") }}</label>
              <b-form-input
                class="input-search"
                ref="searchInput"
                :placeholder="$t('agency.companyPhone')"
                v-model="agency.phone_number"
              ></b-form-input>
            </div>
            <div
              class="d-flex flex-column justify-content-center align-items-center align-self-center m-5"
              
            >
              <label
                :class="{
                  'input-error': validateErrors ? validateErrors.avtar : false,
                }"
                >{{ $t("agency.logo") }}</label
              >
              <avtarInput
                :class="{
                  'input-error': validateErrors ? validateErrors.avtar : false,
                }"
                :avatar="agency.avtar"
                @imageSavedGetNewImage="getAvatarUser"
                @childToParent="getLogo"
                :type="'logo'"
                defaultImage="/images/company-avatar.png"
              ></avtarInput>
            </div>
            <div v-if="agencyData.reviewer_message" class="d-flex flex-row justify-content-center align-self-center m-3" style="color: red;font-style: italic;">
              {{$t('agency.note')}}: {{agencyData.reviewer_message}}
            </div>
            <div
              class="d-flex flex-row justify-content-center align-self-center m-3"
            >
              <b-button class="add-button ml-3" @click="checkForm()">{{
                agency.id ? $t("agency.update") : $t("agency.add")
              }}</b-button>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab
        v-if="agencyData.approved_at"
        @click="infiniteHandler($refs.infiniteLoading)"
      >
        <template v-slot:title>
          <span>{{ $t("userDashboard.agency.addAgents") }}</span>
        </template>
        <div
          class="search-input d-flex flex-row justify-content-between align-items-center"
        >
          <div class="d-flex flex-row align-items-start">
            <b-form-input
              class="input-search"
              :placeholder="$t('userDashboard.messages.search')"
              v-model="config.search"
            ></b-form-input>
            <MagnifyIcon class="icon-search" />
           
          </div>
          <div>{{$t('member')}} {{ agentsList.length }} {{$t('people')}}</div>
        </div>
        <div class="content-body-div">
          <div class="wrap-scroll">
            <div class="wrap-scroll-message">
              <b-row style="margin: 0">
                <template v-for="(item, index) in agentsList">
                  <b-col cols="3" :key="index">
                    <div class="template-item">
                      <div
                        class="button-div d-flex flex-row justify-content-end"
                      >
                        <b-button @click="deleteAgent(item)"
                          ><IconTrash
                        /></b-button>
                        <!-- <b-button><IconSave/></b-button> -->
                      </div>
                      <div
                        v-if="item.agency_profile_image && !item.profile_image"
                        class="agency-logo"
                        :style="{
                          backgroundImage:
                            'url(' + item.agency_profile_image + ')',
                        }"
                      ></div>
                      <div
                        v-if="item.profile_image"
                        class="agency-logo"
                        :style="{
                          backgroundImage: 'url(' + item.profile_image + ')',
                        }"
                      ></div>
                      <div class="title mt-3">{{ item.display_name }}</div>
                      <div class="note mt-3">{{ item.email }}</div>
                    </div>
                  </b-col>
                </template>
              </b-row>
            </div>
            <infinite-loading
              @infinite="infiniteHandler"
              ref="infiniteLoading"
              :distance="-1"
            >
              <span slot="no-results"
                ><b-alert show variant="light" v-if="!agentsList.length">{{
                  $t("adminDashboard.list.dataEmpty")
                }}</b-alert></span
              >
              <span slot="no-more"></span>
            </infinite-loading>
          </div>
        </div>
      </b-tab>
      <b-tab
       v-if="agencyData.approved_at"
        @click="infiniteHandlerForPendingAgents($refs.infiniteLoadingForPendingAgents)"
      >
        <template v-slot:title>
          <span>{{ $t("userDashboard.agency.pendingInvitation") }}</span>
          
        </template>
        <div
          class="search-input d-flex flex-row justify-content-between align-items-center"
        >
          <div class="d-flex flex-row align-items-start">
            <b-form-input
              class="input-search"
              :placeholder="$t('userDashboard.messages.search')"
              v-model="configPendingAgents.search"
            ></b-form-input>
            <MagnifyIcon class="icon-search" />
             <b-button class="add-button ml-3" @click="showPopup()"
              ><IconPlus /> {{$t('add members')}}</b-button
            >
          </div>
          <div>{{$t('member')}} {{ agentsPendingList.length }} {{$t('people')}}</div>
        </div>
        <div class="content-body-div">
          <div class="wrap-scroll">
            <div class="wrap-scroll-message">
              <b-row style="margin: 0">
                <template v-for="(item, index) in agentsPendingList">
                  <b-col cols="3" :key="index">
                    <div class="template-item">
                      <div
                        class="button-div "
                      >
                        <b-button @click="selectedUser=[{id:item.user_id}];addAgents()"
                          ><IconResend style="color:var(--projectPrimaryColor)"
                        /></b-button>
                        <b-button @click="deletePendingInvitation(item)"
                          ><IconTrash
                        /></b-button>
                        <!-- <b-button><IconSave/></b-button> -->
                      </div>
                      <div
                        v-if="item.agency_profile_image && !item.agent.profile_image"
                        class="agency-logo"
                        :style="{
                          backgroundImage:
                            'url(' + item.agency_profile_image + ')',
                        }"
                      ></div>
                      <div
                        v-if="item.agent.profile_image"
                        class="agency-logo"
                        :style="{
                          backgroundImage: 'url(' + item.agent.profile_image + ')',
                        }"
                      ></div>
                      <div class="title mt-3">{{ item.agent.display_name }}</div>
                      <div class="note mt-3">{{ item.agent.email }}</div>
                    </div>
                  </b-col>
                </template>
              </b-row>
            </div>
            <infinite-loading
              @infinite="infiniteHandlerForPendingAgents"
              ref="infiniteLoadingForPendingAgents"
              :distance="-1"
            >
              <span slot="no-results"
                ><b-alert show variant="light" v-if="!agentsPendingList.length">{{
                  $t("adminDashboard.list.dataEmpty")
                }}</b-alert></span
              >
              <span slot="no-more"></span>
            </infinite-loading>
          </div>
        </div>
      </b-tab>
       <b-tab
       v-if="agencyData.approved_at"
        @click="infiniteHandlerListingError($refs.infiniteLoadingForListingError)"
      >
        <template v-slot:title>
          <span>{{ $t("userDashboard.agency.listingError") }}</span>
        </template>
        <div class="content-body-div">
          <div class="wrap-scroll">
            <div class="wrap-scroll-message">
               <b-col cols="12" >
                  <b-row  class="flex-wrap" style="background: #f0f0f0;padding: 10px;">
                    <div class="col-3">Listing Id</div>
                    <div class="col-9">
                      Details
                    </div>
                  </b-row>
                </b-col>
                <template v-for="(item, index) in errorListingXML">
                  <b-col cols="12" :key="index" class="my-3 item">
                    <b-row  class="flex-wrap">
                      <div class="col-3">{{item.id}}</div>
                      <div class="col-9" v-html="JSON.parse(item.response).detail">
                    </div>
                    </b-row>
                  </b-col>
                </template>
            </div>
            <!-- <infinite-loading
              @infinite="infiniteHandlerListingError"
              ref="infiniteLoadingForListingError"
              :distance="-1"
            >
              <span slot="no-results"
                ><b-alert show variant="light" v-if="!errorListingXML.length">{{
                  $t("adminDashboard.list.dataEmpty")
                }}</b-alert></span
              >
              <span slot="no-more"></span>
            </infinite-loading> -->
          </div>
        </div>
       </b-tab>
    </b-tabs>
    <b-modal
      id="popup"
      modal-class="modal-agency-template"
      size="xl"
      centered
      hide-header
      hide-footer
    >
      <div class="p-3">
        <div class="modal-header">
          <h5>{{$t('add members')}}</h5>
        </div>
        <div class="modal-body form-group">
          <div class="input-div col" id="input-group-search">
            <b-form-input
              :class="{
                'active-suggest': isSuggest && suggestList.length,
              }"
              :placeholder="$t('search.search')"
              class="input-search"
              autocomplete="off"
              ref="searchInput"
              @focus="isSuggest = true"
              v-model="emailSearch"
            ></b-form-input>
            <b-form-checkbox-group
              v-if="suggestList.length && isSuggest"
              id="checkbox-1"
              v-model="selectedUser"
              name="checkbox-1"
              class="mt-2"
              style="width: 100%"
              stacked
            >
              <b-form-checkbox
                v-for="(item, index) in suggestList"
                :key="index"
                :value="item"
                class="mb-3"
              >
                <div
                  class="d-flex flex-row justify-content-start align-items-start"
                >
                  <div style="width: 150px">{{ item.display_name }}</div>
                  <div style="text-align: left">{{ item.email }}</div>
                </div>
              </b-form-checkbox>
            </b-form-checkbox-group>
            <div
              v-if="!suggestList.length && emailSearch"
              class="d-flex flex-row justify-content-center align-self-center mt-4"
            >
              {{$t('agency.noUserFound')}}
            </div>
            <b-form-tags
              v-if="selectedUserForTag.length"
              input-id="tags-validation"
              no-outer-focus
              separator=" ,;"
              remove-on-delete
              v-model="selectedUserForTag"
              class="mb-2"
              tag-pills
              size="md"
              :placeholder="''"
              isDuplicate="false"
            >
              <template v-slot="{ tags, removeTag }">
                <b-form-tag v-for="tag in tags" :key="tag" class="mr-1"
                  >{{ tag }}
                  <b-button @click="removeTag(tag)" size="sm" class="delete-tag"
                    >x</b-button
                  >
                </b-form-tag>
              </template>
            </b-form-tags>
            <div
              class="d-flex flex-row justify-content-center align-self-center m-3"
            >
              <b-button class="cancel-button ml-3" @click="closePopup()">{{
                $t("agents.cancel")
              }}</b-button>
              <b-button
                class="add-button ml-3"
                @click="addAgents()"
                :disabled="!selectedUserForTag.length"
                >{{ $t("agents.add") }}</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="popup-message"
      modal-class="modal-agency-template"
      size="xl"
      centered
      hide-header
      hide-footer
    >
      <div class="p-3">
        <div class="d-flex flex-row justify-content-end align-items-end">
          <div @click="closeMessagePopup()" style="cursor: pointer;">
          <IconClose style="width: 25px; height: 25px;" />
          </div>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <p>{{$t('for safety and reliability')}}</p>
          <p>{{$t('Please wait for review and approval of your company creation request')}}</p>
          <p>{{$t('when the request is approved The system will send a confirmation email to the registered email address')}}</p>
        </div>
      </div>
    </b-modal>
    
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import $ from "jquery";
import moment from "moment";
import Loading from "@/components/ui/loading";
import InfiniteLoading from "vue-infinite-loading";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import IconResend from "@/components/icons/IconResend";
import IconPlus from "@/components/icons/IconPlus";
import IconTrash from "@/components/icons/IconTrash";
import IconClose from "@/components/icons/IconClose";
import avtarInput from "@/components/newAvtarUploader";
export default {
  components: {
    // Loading,
    InfiniteLoading,
    MagnifyIcon,
    IconPlus,
    IconTrash,
    avtarInput,
    IconClose,
    IconResend
  },
  data() {
    return {
      config: {
        itemCount: 10,
        take: 10,
        page: 1,
        pageCount: 1,
        search: null,
      },
      configPendingAgents: {
        itemCount: 10,
        take: 10,
        page: 1,
        pageCount: 1,
        search: null,
      },
       listingErrorConfig: {
        itemCount: 10,
        take: 10,
        page: 1,
        pageCount: 1,
        search: null,
      },
      suggestList: [],
      selectedUser: [],
      selectedUserForTag: [],
      agentsList: [],
      agentsPendingList: [],
      errorListingXML: [],
      isSuggest: true,
      emailSearch: null,
      agency: {
        name: null,
        description: "something",
        avtar:null,
        email: null,
        phone_number: null,
      },
      search: null,
      validateErrors: {},
      countError: 0,
    };
  },
  created() {
    this.searchAgency();
  },
  computed: {
    ...mapGetters("AdminAgencyController", ["agencyData"]),
  },
  mounted() {
    this.getAvatarUser();
  },
  watch: {
    "config.search"(val) {
      this.searchAgentsInList();
    },
    "configPendingAgents.search"(val) {
      this.searchAgentsInList();
    },
    emailSearch(val) {
      //console.log("val",val)
      let emailValidate = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/gi;
      if (emailValidate.test(val)) {
        this.searchAgents();
      }
    },
    selectedUserForTag(newVal, oldVal) {
      const removed = oldVal.filter((v) => !newVal.includes(v));
      if (removed && removed.length > 0) {
        removed.forEach((element) => {
          this.selectedUser = this.selectedUser.filter(
            (elm) => elm.email !== element
          );
        });
      }
    },
    selectedUser(val) {
      this.selectedUserForTag = [];
      val.forEach((element) => {
        this.selectedUserForTag.push(element.email);
      });
    },
  },
  methods: {
    ...mapActions("AdminAgencyController", [
      "VERIFY_USER_AGENCY",
      "GET_USER_FOR_AGENCY_BY_EMAIL",
      "ADD_AGENT_TO_AGENCY",
      "GET_AGENT_FOR_AGENCY",
      "DELETE_AGENT_FOR_AGENCY",
      "USER_CREATE_AGENCY",
      "USER_UPDATE_AGENCY",
      'GET_PENDING_AGENTS',
      'DELETE_PENDING_INVITATION_OF_AGENT',
      'GET_LISTING_ERROR_XML'
    ]),
    addAgents() {
      let agent_ids = [];
      this.selectedUser.forEach((element) => {
        agent_ids.push(element.id);
      });
      let parms = {
        id: this.agencyData.id,
        agent_ids: agent_ids,
      };
      this.ADD_AGENT_TO_AGENCY(parms)
        .then((data) => {
          //console.log("added agent");
          this.closePopup();
          this.infiniteHandlerForPendingAgents(this.$refs.infiniteLoadingForPendingAgents)
          this.showToast(this.$t('agency.invitationSent'), "success");
        })
        .catch((err) => {
          this.showToast(this.$t('agency.createdError'), "danger");
        });
    },
    async searchAgency() {
      this.$root.loading = true;
      let response = await this.VERIFY_USER_AGENCY();
      if (response) {
        this.agency.name = response.data.data.name;
        this.agency.description = response.data.data.description;
        this.agency.avtar = response.data.data.logo_url?response.data.data.logo_url:null;
        this.agency.email = response.data.data.email;
        this.agency.phone_number = response.data.data.phone_number;
        this.agency.id = response.data.data.id;
        this.agency.reviewer_message = response.data.data.reviewer_message;
        this.agency.approved_at = response.data.data.approved_at;
        this.$root.loading = false;
        this.$forceUpdate();
      }
      console.log("this.agency",this.agency)
    },
    async searchAgentsInList() {
      let obj={
        id: this.agencyData && this.agencyData.id,
        take: 10,
        page: 1
      };
      if(this.config.search){
        obj.search=this.config.search;
      }
      let response = await this.GET_AGENT_FOR_AGENCY(obj);
      if (response) {
        console.log("response",response)
        this.config.itemCount = response.data.meta.itemCount;
        this.config.take = response.data.meta.take;
        this.config.page = response.data.meta.page;
        this.config.pageCount = response.data.meta.pageCount;
        this.agentsList = response.data.data;
        this.$forceUpdate();
      }
    },
    async searchAgentsInPendingList() {
      let obj={
        take: 10,
        page: 1
      };
      if(this.configPendingAgents.search){
        obj.search=this.configPendingAgents.search;
      }
      let response = await this.GET_AGENT_FOR_AGENCY(obj);
      if (response) {
        this.configPendingAgents.itemCount = response.data.meta.itemCount;
        this.configPendingAgents.take = response.data.meta.take;
        this.configPendingAgents.page = response.data.meta.page;
        this.configPendingAgents.pageCount = response.data.meta.pageCount;
        this.agentsPendingList = response.data.data;
        this.$$forceUpdate();
      }
    },
    async infiniteHandler($state) {
      //console.log("this.agencyData infiniteHandler", this.agencyData);
      if (this.agencyData) {
        let obj={
          id: this.agencyData && this.agencyData.id,
          take: this.config.take,
          page: this.config.page,
        };
        if(this.config.search){
          obj.search= this.config.search;
        }

        let response = await this.GET_AGENT_FOR_AGENCY(obj);
        if (response) {
          //console.log("response", response);
          if (!response.data.data) {
            return $state._uid
              ? $state.stateChanger.complete()
              : $state.complete();
          }
          this.config.itemCount = response.data.meta.itemCount;
          this.config.take = response.data.meta.take;
          this.config.page = response.data.meta.page;
          this.config.pageCount = response.data.meta.pageCount;
          if (this.config.page == 1) {
            this.agentsList = response.data.data;
          } else {
            response.data.data.forEach((elm) => {
              this.agentsList.push(elm);
            });
          }
          if (this.config.page < this.config.pageCount) {
            this.config.page += 1;
            $state._uid ? $state.stateChanger.loaded() : $state.loaded();
          } else
            $state._uid ? $state.stateChanger.complete() : $state.complete();
        }
      }
    },
    async infiniteHandlerForPendingAgents($state) {
      //console.log("this.agencyData infiniteHandler", this.agencyData);
      if (this.agentsPendingList) {
        let obj={
          take: this.configPendingAgents.take,
          page: this.configPendingAgents.page,
        };
        if(this.configPendingAgents.search){
          obj.search= this.configPendingAgents.search;
        }

        let response = await this.GET_PENDING_AGENTS();
        if (response) {
          //console.log("response", response);
          if (!response.data.data) {
            return $state._uid
              ? $state.stateChanger.complete()
              : $state.complete();
          }
          this.configPendingAgents.itemCount = response.data.meta.itemCount;
          this.configPendingAgents.take = response.data.meta.take;
          this.configPendingAgents.page = response.data.meta.page;
          this.configPendingAgents.pageCount = response.data.meta.pageCount;
          if (this.configPendingAgents.page == 1) {
            this.agentsPendingList = response.data.data;
          } else {
            response.data.data.forEach((elm) => {
              this.agentsPendingList.push(elm);
            });
          }
          if (this.configPendingAgents.page < this.configPendingAgents.pageCount) {
            this.configPendingAgents.page += 1;
            $state._uid ? $state.stateChanger.loaded() : $state.loaded();
          } else
            $state._uid ? $state.stateChanger.complete() : $state.complete();
        }
      }
    },
    searchAgents() {
      this.isSuggest = false;
      this.GET_USER_FOR_AGENCY_BY_EMAIL({
        search: this.emailSearch?this.emailSearch: '',
        take: this.config.take,
        page: this.config.page,
      }).then((data) => {
        //console.log("data",data);
        this.isSuggest = true;
        this.suggestList = data.data.data;
        this.$forceUpdate();
      });
    },
    showPopup() {
      this.suggestList = [];
      this.emailSearch = null;
      this.selectedUser = [];
      this.selectedUserForTag = [];
      this.$bvModal.show("popup");
    },
    closePopup() {
      this.$bvModal.hide("popup");
    },
    getAvatarUser() {
      setTimeout(() => {
        if (this.agency.avtar) {
          this.avatar = this.agency.avtar;
          this.$forceUpdate();
        } else {
          this.avatar = "/images/avatar.png";
          this.$forceUpdate();
        }
      }, 500);
    },
    getLogo(ev) {
      this.agency.avtar = ev.file;
    },
    showToast(text, type) {
      this.$bvToast.toast(text, {
        title: text,
        variant: type,
        solid: true,
      });
    },
    deleteAgent(item) {
      this.$swal({
        title: this.$t("Are you sure you want to delete"),
        text: item.display_name,
        customClass: {
          container: "swal-del-item",
        },
        showCancelButton: true,
        cancelButtonColor: "var(--projectPrimaryColor) !important",
        confirmButtonColor: "#DC3849",
        cancelButtonText: this.$i18n.t(
          "userDashboard.userManage.modal.btnConfirm"
        ),
        confirmButtonText: this.$i18n.t(
          "userDashboard.userManage.modal.btnCancel"
        ),
        preConfirm: () => {
          this.DELETE_AGENT_FOR_AGENCY({
            id: this.agencyData.id,
            agentId: item.id,
          })
            .then((data) => {
              this.showToast(this.$t('agency.agencyDeleted'), "success");
              this.searchAgentsInList();
            })
            .catch((err) => {
              this.showToast(this.$t('agency.createdError'), "danger");
            });
        },
      });
    },
    checkForm(e) {
      this.countError = 0;
      this.validateErrors = {};
      this.isValidate = true;
      if (this.agency.name && this.agency.name.match(/[\u1000-\uFFFF]+/g)) {
        this.validateErrors[`name`] = true;
        this.countError++;
        this.makeToastError(this.$t("Marks or special characters are not allowed"));
        return;
      }
      if (!this.agency.name) {
        this.validateErrors[`name`] = true;
        this.countError++;
      }

      
      if (!this.agency.avtar) {
        this.validateErrors[`avtar`] = true;
        this.countError++;
      }
      //console.log("this.validateErrors", this.validateErrors);
      this.addAgency();
    },
    addAgency() {
      this.$root.loading = true;
      if (!this.countError) {
        let agencyFormData = new FormData();
        agencyFormData.append("name", this.agency.name);
        agencyFormData.append("description", this.agency.description);
        agencyFormData.append("file", this.agency.avtar);
        if (this.agency.phone_number) {
          agencyFormData.append("phone_number", this.agency.phone_number);
        }
        if (this.agency.email) {
          agencyFormData.append("email", this.agency.email);
        }
        agencyFormData.append("file", this.agency.avtar);
        if (!this.agencyData.logo_url) {
          this.USER_CREATE_AGENCY(agencyFormData)
            .then((data) => {
              this.showToast(this.$t('agency.companyDetailsSaved'), "success");
              this.searchAgency();
              this.$root.loading = false;
              this.showPopuo();
              //console.log("data", data);
            })
            .catch((err) => {
              this.$root.loading = false;
              this.showToast(err.message, "danger");
            });
        } else {
          this.USER_UPDATE_AGENCY({
            agencyId: this.agencyData.id,
            formData: agencyFormData,
          })
            .then((data) => {
              this.showToast(this.$t('agency.companyDetailsSaved'), "success");
              this.searchAgency();
              this.$root.loading = false;
              this.showPopuo();
              //console.log("data", data);
            })
            .catch((err) => {
              this.$root.loading = false;
              this.showToast(err.detail.message, "danger");
            });
        }
      } else {
        this.$root.loading = false;
        this.showToast(this.$t('agency.checkForm'), "danger");
      }
    },
    showPopuo(){
      this.$bvModal.show("popup-message");
    },
    closeMessagePopup(){
      this.$bvModal.hide("popup-message");
      window.location.reload();
    },
    deletePendingInvitation(agent){
      this.$swal({
        title: this.$t("Are you sure you want to delete"),
        text: agent.agent.display_name,
        customClass: {
          container: "swal-del-item",
        },
        showCancelButton: true,
        cancelButtonColor: "var(--projectPrimaryColor) !important",
        confirmButtonColor: "#DC3849",
        cancelButtonText: this.$i18n.t(
          "userDashboard.userManage.modal.btnConfirm"
        ),
        confirmButtonText: this.$i18n.t(
          "userDashboard.userManage.modal.btnCancel"
        ),
        preConfirm: () => {
          this.DELETE_PENDING_INVITATION_OF_AGENT({id:agent.id}).then((data)=>{
            this.showToast('Invitation Deleted','success');
            this.infiniteHandlerForPendingAgents(this.$refs.infiniteLoadingForPendingAgents)
          }).catch(err=>{
            console.log("err")
            this.showToast(this.$t('agency.createdError'), "danger");
          })
        },
      });
    },
    async infiniteHandlerListingError($state) {
      //console.log("this.agencyData infiniteHandler", this.agencyData);
      if (this.agencyData) {
        

        let response = await this.GET_LISTING_ERROR_XML();
        if (response) {
          //console.log("response", response);
          if (!response.data.data) {
            return $state._uid
              ? $state.stateChanger.complete()
              : $state.complete();
          }
          // this.listingErrorConfig.itemCount = response.data.meta.itemCount;
          // this.listingErrorConfig.take = response.data.meta.take;
          // this.listingErrorConfig.page = response.data.meta.page;
          // this.listingErrorConfig.pageCount = response.data.meta.pageCount;
          console.log("response",response.data.data)
          if (this.listingErrorConfig.page == 1) {
            this.errorListingXML = response.data.data;
          } else {
            response.data.data.forEach((elm) => {
              this.errorListingXML.push(elm);
            });
          }
          // if (this.listingErrorConfig.page < this.listingErrorConfig.pageCount) {
          //   this.listingErrorConfig.page += 1;
          //   $state._uid ? $state.stateChanger.loaded() : $state.loaded();
          // } else
          //   $state._uid ? $state.stateChanger.complete() : $state.complete();
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "userManageAgents.scss";
</style>


